<template>
  <header>
    <div class="header d-flex justify-content-between">
      <div class="header_title">日刊ゲンダイBoatRace{{ environmentName }}</div>
      <div v-if="isLogin" class="user_info d-flex flex-row">
        <div class="user_name" v-text="loginName + ' |'"></div>
        <a class="logout_button" @click="logout()">
          <p>ログアウト</p>
        </a>
      </div>
    </div>
  </header>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useStore } from "@/store/authStore";
import { computed } from "vue";

const store = useStore(); // Pinia storeを使用します
const router = useRouter();

const environmentName = computed(() => {
  return process.env.VUE_APP_ENV_NAME;
});

const color = computed(() => {
  return process.env.VUE_APP_ENV_COLOR;
});

let loginName = computed(() => {
  if (
    store.getPayload &&
    store.getPayload.userInfo &&
    store.getPayload.userInfo.data &&
    store.getPayload.userInfo.data.name
  ) {
    return store.getPayload.userInfo.data.name; // 「payload」オブジェクトの中の「name」フィールドを取得します
  } else {
    return null;
  }
});

const isLogin = computed(() => {
  return store.getIsLogin;
});

const logout = async () => {
  await store.logout(); // Storeのlogoutメソッドを呼び出す
  return router.push("/login");
};
</script>
<style scoped>
header {
  width: 100%;
  height: auto;
  background-color: v-bind(color);
}

.header_title {
  font-size: 20px;
  color: white;
  text-align: left;
  margin: 10px;
  white-space: nowrap;
}

.user_info {
  height: 2rem;
  margin: 0.6rem;
}

.logout_button {
  text-decoration-color: #fff;
  margin-left: 1.4rem;
}

.logout_button:hover {
  opacity: 0.6;
}

.logout_button p {
  color: #fff;
  font-weight: bold;
  margin: 0;
  margin-top: 0.2rem;
  font-size: 1.2rem;
  white-space: nowrap;
}

.user_name {
  color: #fff;
  font-size: 1.4rem;
}
</style>
